"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withFunctionReport = exports.withReport = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var init_aegis_1 = tslib_1.__importDefault(require("../_util/init-aegis"));
var ErrorBoundary = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        init_aegis_1.default.report({
            msg: {
                errorType: 'componentDidCatch',
                ComponentName: this.props.componentName,
                error: error,
                errorInfo: errorInfo,
            },
            level: 4,
            ext1: this.props.componentName,
        });
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return react_1.default.createElement("h1", null, "\u53D1\u751F\u5F02\u5E38\u4E86\uFF0C\u8BF7\u91CD\u8BD5");
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(react_1.default.Component));
function withReport(WrappedComponent) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var ComponentWithReport = (0, react_1.forwardRef)(function (props, ref) {
        var componentName = WrappedComponent.displayName || WrappedComponent.name || 'unknown';
        (0, react_1.useEffect)(function () {
            try {
                init_aegis_1.default.report({
                    msg: {
                        ComponentName: componentName,
                        props: props,
                    },
                    level: 2048,
                    ext1: componentName,
                });
            }
            catch (e) { }
        }, []);
        return react_1.default.createElement(ErrorBoundary, { componentName: componentName },
            react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, props, { ref: ref })));
    });
    return ComponentWithReport;
}
exports.withReport = withReport;
// eslint-disable-next-line @typescript-eslint/ban-types
function withFunctionReport(fn, displayName) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var componentName = displayName || fn.name || 'unknown';
        try {
            init_aegis_1.default.report({
                msg: {
                    ComponentName: componentName,
                    props: args,
                },
                level: 2048,
                ext1: componentName,
            });
        }
        catch (e) { }
        return fn.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
    };
}
exports.withFunctionReport = withFunctionReport;
//# sourceMappingURL=withReport.js.map